import _extends from "@babel/runtime/helpers/extends";
import React from "react";
import styled, { css } from "styled-components";
import TextareaAutosize from "react-textarea-autosize";
import Label from "~/components-shared/Label";
import EmojiDropdown from "~/components-shared/EmojiDropdown";
import { genericColor } from "~/lib/resolvers";
const Wrapper = styled.div`
  width: 100%;
  ${_ref => {
  let {
    $maxWidth
  } = _ref;
  return $maxWidth && `max-width: ${$maxWidth}`;
}};
  ${_ref2 => {
  let {
    s,
    theme
  } = _ref2;
  return theme.spacing.resolve(theme, s);
}};
`;
const TextArea = styled(TextareaAutosize)`
  background-color: transparent;
  width: 100%;
  border: none;
  font-size: 1.2rem;
  line-height: 1.4em;
  font-weight: ${_ref3 => {
  let {
    theme
  } = _ref3;
  return theme.typography.fontWeight.regular;
}};
  outline: none;
`;
const Error = styled.span`
  font-size: 0.8rem;
  display: inline-block;
  margin-left: 0.5rem;
  color: ${_ref4 => {
  let {
    theme
  } = _ref4;
  return theme.colors.danger.main;
}};
`;
const Container = styled.div`
  background-color: ${_ref5 => {
  let {
    theme,
    $color
  } = _ref5;
  return genericColor(theme, $color);
}};
  ${_ref6 => {
  let {
    $outline,
    theme
  } = _ref6;
  return theme.shadows.outline(theme, $outline);
}};
  padding: ${_ref7 => {
  let {
    $shiftLeft
  } = _ref7;
  return $shiftLeft ? "0.7rem 2rem 0.7rem 0.9rem" : "0.7rem 0.9rem";
}};
  border-radius: ${_ref8 => {
  let {
    $rounded,
    theme
  } = _ref8;
  return $rounded ? "2rem" : theme.shape.borderRadius.primary;
}};
  position: relative;
  z-index: 1;
  &:before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    transition: background-color 200ms ease-out;
    background-color: transparent;
    border-radius: ${_ref9 => {
  let {
    $rounded,
    theme
  } = _ref9;
  return $rounded ? "2em" : theme.shape.borderRadius.primary;
}};
    z-index: -1;
  }

  ${_ref10 => {
  let {
    $disabled
  } = _ref10;
  return !$disabled && css`
      &:hover:before {
        background-color: ${_ref11 => {
    let {
      theme
    } = _ref11;
    return theme.colors.action.hover;
  }};
      }
    `;
}}
`;
const StyledInputEmoji = styled(EmojiDropdown)`
  position: absolute;
  top: 0.7rem;
  right: 0.9rem;
`;
const InputTextArea = _ref12 => {
  let {
    error,
    label,
    required = false,
    disabled = false,
    value,
    onChange = () => false,
    rounded = false,
    rows = 6,
    s,
    outline,
    emojiPicker = false,
    color = "translucent",
    maxWidth,
    labelProps,
    children,
    ...rest
  } = _ref12;
  return /*#__PURE__*/React.createElement(Wrapper, {
    s: s,
    $maxWidth: maxWidth
  }, !!label && /*#__PURE__*/React.createElement(Label, _extends({
    required: required,
    s: {
      mb: 2
    }
  }, labelProps), label), /*#__PURE__*/React.createElement(Container, {
    $color: color,
    $shiftLeft: emojiPicker,
    $error: !!error,
    $outline: outline,
    $disabled: disabled,
    $rounded: rounded
  }, /*#__PURE__*/React.createElement(TextArea, _extends({
    value: value,
    onChange: e => onChange(e.target.value),
    minRows: rows,
    disabled: disabled,
    $rounded: rounded
  }, rest)), emojiPicker && /*#__PURE__*/React.createElement(StyledInputEmoji, {
    onChange: emoji => onChange(`${value}${emoji}`)
  }), children), error && /*#__PURE__*/React.createElement(Error, null, error));
};
export default InputTextArea;